import React, { useState } from 'react';
import './SearchResults.css';
import DocumentCard from './DocumentCard';
import Pagination from './Pagination';

function SearchResults({ documents, total, query, onOpenDocument }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil((total || 0) / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentDocuments = (documents || []).slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="search-results">
      <div className="documents-list">
        {currentDocuments.map((doc, index) => (
          <DocumentCard key={doc.id || doc.ucid || index} document={doc} onOpenDocument={onOpenDocument} />
        ))}
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
}

export default SearchResults;

